import { useContext, useEffect } from 'react'
import { getIrmAffiliations } from 'services/irmAffiliations'
import { Context as IrmAffiliationContext } from '../contexts/IrmAffiliationContext'

function useIrmAffiliations(affiliatedId) {
  const context = useContext(IrmAffiliationContext)
  if (!context) {
    throw new Error(`useIrmAffiliations must be used within an IrmAffiliationProvider`)
  }
  const [state, dispatch] = context

  useEffect(() => {
    const fetchIrmAffiliations = async ({ affiliatedId }) => {
      try {
        const options = {
          affiliated_id: affiliatedId,
          page_offset: state.page * state.rowsPerPage, // Need to start at 0 to support @material-ui pagination
          page_size: Number(state.rowsPerPage),
        }
        dispatch({ type: 'IRM_AFFILIATION:FETCH_STARTED' })
        const { data, total } = await getIrmAffiliations(options)
        dispatch({
          type: 'IRM_AFFILIATION:FETCH_RECEIVED',
          payload: {
            affiliations: data,
            total: total,
            page: state.page,
            rowsPerPage: state.rowsPerPage,
          },
        })
      } catch (error) {
        dispatch({ type: 'IRM_AFFILIATION:FAILED', payload: error })
      }
    }

    if (affiliatedId) {
      fetchIrmAffiliations({ affiliatedId })
    }
  }, [dispatch, affiliatedId, state.page, state.rowsPerPage])

  const setPage = page => {
    dispatch({ type: 'IRM_AFFILIATION:SET_PAGE', payload: { page } })
  }

  const setRowsPerPage = ({ page, rowsPerPage }) => {
    dispatch({ type: 'IRM_AFFILIATION:SET_ROWS_PER_PAGE', payload: { page, rowsPerPage } })
  }

  return {
    state,
    setPage,
    setRowsPerPage,
  }
}

export default useIrmAffiliations
